module.exports = {"domain":"pdview.au.auth0.com","clientID":"fmPFrn3aFwG9z6QBc8z0KX4GbkjlllGD","audience":"https://pdview.au.auth0.com/userinfo","responseType":"token id_token","scope":"openid profile email","prompt":"none"}


//////////////////
// WEBPACK FOOTER
// ./src/config/auth0.json
// module id = 537
// module chunks = 0